<template>
    <h3 :class="['h-label', (border ? '' : 'border-0')]">
        <span class="upper">
            <slot name="upper">{{ upper }}</slot>
        </span>
        <span v-if="lower || $slots.lower" :class="'lower size-' + size">
            <slot name="lower">{{ lower }}</slot>
        </span>
    </h3>
</template>

<script>
    export default {
        props: {
            upper: String,
            lower: String|Number,
            border: Boolean,
            size: {
                type: String,
                default: 'normal'
            }
        },
    }
</script>
